import React, { createContext, useContext } from "react";
import { DietFormData } from "@/components/diet/types";

interface DietContextType {
    formData: DietFormData;
    setFormData: React.Dispatch<React.SetStateAction<DietFormData>>;
    step: number;
    setStep: React.Dispatch<React.SetStateAction<number>>;
    emptyFormData: () => DietFormData;
}

export const DietContext = createContext<DietContextType | undefined>(undefined);

export const useDietContext = () => {
    const context = useContext(DietContext);
    if (!context) {
        throw new Error("useDietContext must be used within a DietProvider");
    }
    return context;
};

